import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const FormFilterDate = ({ handleInfo, downloadFile, exportCSV, exportXLS }) => {
  const [showBtn, setShowBtn] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    setValue("date_to", today);
  }, [setValue, today]);

  const onSubmit = (data) => {
    handleInfo(data);
    setShowBtn(true);
  };

  return (
    <>
      <div className="container bg-white shadow rounded p-4 pt-3">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row d-flex">
            <div
              className={
                !downloadFile
                  ? "col-12 col-sm-12 col-md-6 col-lg-4"
                  : `col-12 col-sm-12 col-md-6 col-lg-${showBtn ? "3" : "4"}`
              }
            >
              <label htmlFor="date_from" className="form-label">
                FECHA DESDE
              </label>
              <input
                type="date"
                name="date_from"
                id="date_from"
                className={`form-control ${errors.date_from && "is-invlid"}`}
                {...register("date_from", {
                  required: true,
                  message: "Campo obligatorio",
                })}
              />
              {errors.date_from && (
                <p className="invalid-feedback">{errors.date_from.message}</p>
              )}
            </div>
            <div
              className={
                !downloadFile
                  ? "col-12 col-sm-12 col-md-6 col-lg-4"
                  : `col-12 col-sm-12 col-md-6 col-lg-${showBtn ? "3" : "4"}`
              }
            >
              <label htmlFor="date_to" className="form-label">
                FECHA HASTA
              </label>
              <input
                type="date"
                name="date_to"
                id="date_to"
                className="form-control"
                {...register("date_to", {
                  required: true,
                  message: "Campo obligatorio",
                })}
              />
              {errors.date_to && (
                <p className="invalid-feedback">{errors.date_to.message}</p>
              )}
            </div>
            <div
              className={
                !downloadFile
                  ? "col-12 col-sm-12 col-md-6 col-lg-4 mt-2"
                  : `col-12 col-sm-12 col-md-6 col-lg-${showBtn ? "3" : "4"} mt-2`
              }
            >
              <div className="row mt-4">
                <button className="btn btn-success">BUSCAR</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default FormFilterDate;